import React, { useState } from 'react';
import CommonDatePicker from '../../components/DatePicker/CommonDatePicker';
import { updateTodo } from '../../api/todoApi';
import '../../css/todo.css';

const REF_TYPE_LABEL = { board: '게시판', approval: '전자결재', resource: '자원예약', schedule: '일정', pms_checklist: '프로젝트', pms_comment: '프로젝트', pms_feed: '프로젝트' };
const DUE_OPTIONS = [
  { value: 'none',     label: '기한 없음' },
  { value: 'today',    label: '오늘' },
  { value: 'tomorrow', label: '내일' },
  { value: 'custom',   label: '날짜 선택' },
];
const PRIORITY_OPTIONS = [
  { value: 'high',   label: '높음' },
  { value: 'normal', label: '보통' },
  { value: 'low',    label: '낮음' },
];

function TodoListEdit({ todo: initialTodo, onUpdated, onCancel }) {
  const todo = initialTodo || {
    todo_id: 1,
    title: '',
    memo: '',
    priority: 'normal',
    due_type: 'none',
    due_date: '',
    reg_date: '',
    completed_at: '',
    ref_type: 'board',
  };
  const [title,    setTitle]    = useState(todo.title || '');
  const [memo,     setMemo]     = useState(todo.memo || '');
  const [priority, setPriority] = useState(todo.priority || 'normal');
  const [dueType,  setDueType]  = useState(todo.due_type || 'none');
  const [dueDate,  setDueDate]  = useState(
    todo.due_date && typeof todo.due_date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(todo.due_date)
      ? todo.due_date
      : (todo.due_date ? new Date(todo.due_date) : '')
  );
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState('');
  const token = sessionStorage.getItem('token');

  const handleSubmit = async () => {
    if (!title.trim()) { setError('제목을 입력해주세요.'); return; }
    if (dueType === 'custom' && !dueDate) { setError('기한일을 선택해주세요.'); return; }
    setError('');
    setLoading(true);
    try {
      let dueDateStr = null;
      if (dueType === 'custom') {
        if (typeof dueDate === 'string') {
          dueDateStr = dueDate;
        } else if (dueDate instanceof Date && !isNaN(dueDate)) {
          const yyyy = dueDate.getFullYear();
          const mm = String(dueDate.getMonth() + 1).padStart(2, '0');
          const dd = String(dueDate.getDate()).padStart(2, '0');
          dueDateStr = `${yyyy}-${mm}-${dd}`;
        }
      }
      await updateTodo(todo.todo_id, {
        title: title.trim(),
        memo: memo || null,
        priority,
        due_type: dueType,
        due_date: dueDateStr,
      }, token);
      if (onUpdated) onUpdated();
    } catch (err) {
      setError('수정 중 오류가 발생했습니다.');
    } finally {
      setLoading(false);
    }
  };

  // 오늘 날짜 (yyyy-mm-dd)
  const todayStr = new Date().toISOString().slice(0, 10);
  let dateStr = '';
  if (typeof dueDate === 'string') {
    dateStr = dueDate;
  } else if (dueDate instanceof Date && !isNaN(dueDate)) {
    const yyyy = dueDate.getFullYear();
    const mm = String(dueDate.getMonth() + 1).padStart(2, '0');
    const dd = String(dueDate.getDate()).padStart(2, '0');
    dateStr = `${yyyy}-${mm}-${dd}`;
  }
  const isOverdue = dateStr && dateStr < todayStr && dueType !== 'none';

  return (
    <div className="todo-detail-card">
      {/* 상단 버튼 그룹 - 왼쪽 타이틀, 오른쪽 버튼 */}
      <div className="todo-top-actions" style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
        <span style={{ fontSize: 22, fontWeight: 700, color: '#1f2937', marginRight: 20, whiteSpace: 'nowrap' }}>To-Do 수정</span>
        <div style={{ display: 'flex', gap: 8, flex: 1, justifyContent: 'flex-end' }}>
          <button className="btn btn-sm btn-outline-primary" onClick={handleSubmit} disabled={loading}>
            {loading ? '수정 중...' : '수정'}
          </button>
          <button className="btn btn-sm btn-outline-secondary" onClick={onCancel}>
            취소
          </button>
        </div>
      </div>
      <div style={{ borderBottom: '1px solid #e0e0e0', margin: '12px 0 16px 0' }} />

      {/* 상단 정보 및 상태 */}
      {(todo.reg_date || todo.completed_at) && (
        <div className="todo-layer-row" style={{ gap: 16, alignItems: 'center', minHeight: 40 }}>
          <div style={{ display: 'flex', alignItems: 'center', flex: 1, gap: 8, minHeight: 40 }}>
            <label className="todo-layer-label" style={{ minWidth: 48, height: 40, display: 'flex', alignItems: 'center', fontSize: 12, justifyContent: 'center' }}>등록일</label>
            <div style={{ minWidth: 0, flex: 1, background: '#f8f9fa', color: '#222', fontSize: 12, fontWeight: 500, lineHeight: '20px', padding: '0 8px', borderRadius: 4, height: 28, display: 'flex', alignItems: 'center' }}>
              {todo.reg_date ? String(todo.reg_date).replace('T', ' ').slice(0, 16) : '-'}
            </div>
          </div>
          {todo.completed_at && (
            <div style={{ display: 'flex', alignItems: 'center', flex: 1, gap: 8, minHeight: 40 }}>
              <label className="todo-layer-label" style={{ minWidth: 48, height: 40, display: 'flex', alignItems: 'center', fontSize: 12, justifyContent: 'center' }}>완료일</label>
              <div style={{ minWidth: 0, flex: 1, background: '#f8f9fa', color: '#222', fontSize: 12, fontWeight: 500, lineHeight: '20px', padding: '0 8px', borderRadius: 4, height: 28, display: 'flex', alignItems: 'center' }}>
                {todo.completed_at ? String(todo.completed_at).replace('T', ' ').slice(0, 16) : '-'}
              </div>
            </div>
          )}
        </div>
      )}

      {/* [추가] 프로젝트명 (프로젝트 연동 데이터인 경우에만 표시) */}
      {todo.ref_type?.startsWith('pms_') && todo.add_title && (
        <div className="todo-layer-row" style={{ alignItems: 'center', minHeight: 40 }}>
          <label className="todo-layer-label" style={{ display: 'flex', alignItems: 'center', height: 40, fontSize: 12, justifyContent: 'center' }}>프로젝트</label>
          <div style={{ flex: 1, display: 'flex', alignItems: 'center', minWidth: 0, height: 40 }}>
            <div
              style={{
                background: '#f8f9fa',
                flex: '1 1 0',
                minWidth: 0,
                maxWidth: 420,
                color: '#0d6efd',
                fontSize: 12,
                fontWeight: 700,
                lineHeight: '20px',
                padding: '0 8px',
                borderRadius: 4,
                height: 28,
                display: 'flex',
                alignItems: 'center',
              }}
              title={todo.add_title}
            >
              {todo.add_title}
            </div>
          </div>
        </div>
      )}

      {/* 제목, 상태 */}
      <div className="todo-layer-row" style={{ alignItems: 'center', minHeight: 40 }}>
        <label className="todo-layer-label" style={{ display: 'flex', alignItems: 'center', height: 40, fontSize: 12, justifyContent: 'center' }}>{todo.ref_type === 'pms_checklist' || todo.ref_type === 'pms_comment' ? '상세항목' : '제목'}</label>
        <div style={{ flex: 1, display: 'flex', alignItems: 'center', minWidth: 0, height: 40 }}>
          <input
            type="text"
            className="form-control form-control-sm"
            style={{ background: '#f8f9fa', flex: 1, minWidth: 0, maxWidth: 700, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', color: '#222', fontSize: 12, fontWeight: 500, lineHeight: '20px', padding: '0 8px', borderRadius: 4, height: 20, display: 'block' }}
            value={title}
            onChange={e => setTitle(e.target.value)}
            maxLength={200}
            placeholder="To-Do 제목"
          />
          <span className={`badge ${todo.completed_at ? 'bg-success' : 'bg-warning text-dark'}`} style={{ marginLeft: 8, flexShrink: 0 }}>
            {todo.completed_at ? '완료' : '미완료'}
          </span>
        </div>
      </div>

      {/* 등록구분/중요도 */}
      <div className="todo-layer-row" style={{ display: 'flex', alignItems: 'center', minHeight: 40, gap: 16 }}>
        {/* 등록구분(왼쪽) */}
        <div style={{ flex: 1, display: 'flex', alignItems: 'center', gap: 8, minWidth: 0, minHeight: 40 }}>
          <label className="todo-layer-label" style={{ display: 'flex', alignItems: 'center', height: 40, fontSize: 12, justifyContent: 'center' }}>등록구분</label>
          <div style={{ background: '#f8f9fa', color: '#222', fontSize: 12, fontWeight: 500, lineHeight: '20px', padding: '0 8px', borderRadius: 4, height: 28, display: 'flex', alignItems: 'center', minWidth: 0, flex: 1 }}>{REF_TYPE_LABEL[todo.ref_type] || todo.ref_type}</div>
        </div>
        {/* 중요도(오른쪽) */}
        <div style={{ flex: 1, display: 'flex', alignItems: 'center', gap: 8, minWidth: 0, minHeight: 40 }}>
          <label className="todo-layer-label" style={{ fontSize: 12, display: 'flex', alignItems: 'center', height: 40, justifyContent: 'center' }}>중요도</label>
          <div className="todo-layer-chip-group" style={{ display: 'flex', gap: 6, alignItems: 'center', height: 40, minHeight: 40 }}>
            {PRIORITY_OPTIONS.map(opt => {
              let chipClass = `todo-layer-chip todo-layer-chip--priority-${opt.value}`;
              if (priority === opt.value) chipClass += ' active';
              return (
                <span
                  key={opt.value}
                  className={chipClass}
                  style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', height: 32, minWidth: 36, fontSize: 12, fontWeight: 500, verticalAlign: 'middle', background: priority === opt.value ? '#198754' : '#e9ecef', color: priority === opt.value ? '#fff' : '#222', border: 'none', cursor: 'pointer', userSelect: 'none', boxShadow: 'none', pointerEvents: 'auto', padding: '0 8px' }}
                  onClick={() => setPriority(opt.value)}
                >
                  {opt.label}
                </span>
              );
            })}
          </div>
        </div>
      </div>

      {/* 기한 칩들과 날짜(라벨+값)를 한 줄에 모두 표시 */}
      <div className="todo-layer-row todo-layer-row--chips" style={{ alignItems: 'center', gap: 8, minHeight: 40 }}>
        <label className="todo-layer-label" style={{ fontSize: 12, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>기한</label>
        <div className="todo-layer-chip-group" style={{ display: 'flex', gap: 6, alignItems: 'center', height: 32 }}>
          {DUE_OPTIONS.map(opt => {
            let chipClass = 'todo-layer-chip';
            if (dueType === opt.value) chipClass += ' active';
            return (
              <button
                key={opt.value}
                className={chipClass}
                style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', height: 32, minWidth: 36, fontSize: 12, fontWeight: 500, verticalAlign: 'middle', background: dueType === opt.value ? '#198754' : '#e9ecef', color: dueType === opt.value ? '#fff' : '#222', border: 'none', cursor: 'pointer', userSelect: 'none', boxShadow: 'none', pointerEvents: 'auto', padding: '0 8px' }}
                onClick={() => {
                  if (opt.value === 'today') {
                    const today = new Date();
                    const yyyy = today.getFullYear();
                    const mm = String(today.getMonth() + 1).padStart(2, '0');
                    const dd = String(today.getDate()).padStart(2, '0');
                    setDueType('today');
                    setDueDate(`${yyyy}-${mm}-${dd}`);
                  } else if (opt.value === 'tomorrow') {
                    const tomorrow = new Date();
                    tomorrow.setDate(tomorrow.getDate() + 1);
                    const yyyy = tomorrow.getFullYear();
                    const mm = String(tomorrow.getMonth() + 1).padStart(2, '0');
                    const dd = String(tomorrow.getDate()).padStart(2, '0');
                    setDueType('tomorrow');
                    setDueDate(`${yyyy}-${mm}-${dd}`);
                  } else if (opt.value === 'custom') {
                    const today = new Date();
                    const yyyy = today.getFullYear();
                    const mm = String(today.getMonth() + 1).padStart(2, '0');
                    const dd = String(today.getDate()).padStart(2, '0');
                    setDueType('custom');
                    setDueDate(`${yyyy}-${mm}-${dd}`);
                  } else if (opt.value === 'none') {
                    setDueType('none');
                    setDueDate('');
                  }
                }}
                type="button"
              >
                {opt.label}
              </button>
            );
          })}
        </div>
        {/* 날짜: 기한 없음이 아니면 라벨+값+기한지남 한 줄에 */}
        {dueType !== 'none' && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 4, marginLeft: 12, minHeight: 40, flex: 1 }}>
            <label className="todo-layer-label" style={{ fontSize: 12, minWidth: 28, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>날짜</label>
            {dueType === 'custom' ? (
              <CommonDatePicker
                value={typeof dueDate === 'string' ? (dueDate ? new Date(dueDate) : null) : (dueDate instanceof Date && !isNaN(dueDate) ? dueDate : null)}
                onChange={date => {
                  if (date instanceof Date && !isNaN(date)) {
                    const yyyy = date.getFullYear();
                    const mm = String(date.getMonth() + 1).padStart(2, '0');
                    const dd = String(date.getDate()).padStart(2, '0');
                    setDueDate(`${yyyy}-${mm}-${dd}`);
                  } else {
                    setDueDate('');
                  }
                }}
                placeholder="날짜 선택"
                inputClassName="todo-date-input form-control form-control-sm"
                style={{ width: 110, minWidth: 0, display: 'inline-block' }}
              />
            ) : (
              <input
                type="text"
                className="todo-date-input form-control form-control-sm"
                value={typeof dueDate === 'string' ? dueDate : ''}
                readOnly
                tabIndex={-1}
                style={{ background: '#e9ecef', color: '#222', width: 110, minWidth: 0, display: 'inline-block' }}
              />
            )}
            <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
              {isOverdue && (
                <span style={{ color: '#d32f2f', fontWeight: 700, fontSize: 12, background: '#ffeaea', borderRadius: 4, padding: '2px 10px', height: 24, display: 'flex', alignItems: 'center', marginLeft: 8 }}>
                  [기한지남]
                </span>
              )}
            </div>
          </div>
        )}
      </div>

      {/* 메모 */}
      <div className="todo-layer-row" style={{ minHeight: 40, alignItems: 'center' }}>
        <label className="todo-layer-label" style={{ fontSize: 12, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>메모</label>
        <textarea
          className="form-control form-control-sm"
          style={{ background: '#f8f9fa', height: 100, fontSize: 12, resize: 'vertical' }}
          value={memo}
          onChange={e => setMemo(e.target.value)}
          maxLength={500}
          placeholder="메모 (선택)"
        />
      </div>
      {/* 오류 메시지 */}
      {error && <div className="todo-layer-error">{error}</div>}
    </div>
  );
}

export default TodoListEdit;
